import React from 'react';

import type { SuggestedEditKind } from '@aline/common';
import { Select } from '@aline/common';
import { Sparkles } from 'lucide-react';
import { makeStyles } from 'tss-react/mui';

import { SUGGESTION_CHIP_LABELS, SUGGESTION_TONES } from './suggestion-tones';
import { SuggestionRationaleTooltip } from './SuggestionRationaleTooltip';

const useStyles = makeStyles<{ kind: SuggestedEditKind }>()((theme, { kind }) => ({
  chip: {
    alignItems: 'center',
    backgroundColor: SUGGESTION_TONES[kind].background,
    borderColor: SUGGESTION_TONES[kind].border,
    borderRadius: 999,
    borderStyle: 'solid',
    borderWidth: 1,
    color: SUGGESTION_TONES[kind].color,
    display: 'inline-flex',
    flexShrink: 0,
    fontSize: 11,
    fontWeight: 500,
    gap: theme.spacing(0.5),
    lineHeight: '16px',
    padding: theme.spacing(0, 0.75),
    whiteSpace: 'nowrap',
  },
}));

/** The kind badge: green add, amber change, red delete. Copy is a design pass; the kind mapping is binding. */
export const SuggestionChip = React.memo(function SuggestionChip({
  kind,
  label,
  rationales = [],
}: {
  kind: SuggestedEditKind;
  label?: string;
  /** Why the AI proposed this, shown on hover. */
  rationales?: readonly string[];
}): JSX.Element {
  const { classes } = useStyles({ kind });

  return (
    <SuggestionRationaleTooltip rationales={rationales}>
      <span className={classes.chip} data-cy={Select.playbooks.suggestionChip} data-kind={kind}>
        <Sparkles size={11} strokeWidth={1.5} />
        {label ?? SUGGESTION_CHIP_LABELS[kind]}
      </span>
    </SuggestionRationaleTooltip>
  );
});
